// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="(\$ctrl.areaId ? 'Update' : 'Create') + ' area'"></sub-header>

  <div class="form-section">

    <form name="\$ctrl.areaForm">
      <div class="form-section">
        <form-section form-title="'Properties'">
          <form-section-field field-title="'Name'">
            <input ng-model="\$ctrl.area.name"
                   type="text"
                   required/>
          </form-section-field>
          <form-section-field field-title="'Description'">
            <input ng-model="\$ctrl.area.description"
                   type="text"/>
          </form-section-field>
          <form-section-field field-title="'Parent area'">
            <input disabled
                   type="text"
                   ng-model="\$ctrl.area.parent.name"/>
          </form-section-field>
        </form-section>

        <form-section form-title="'Areas'">
          <ul ng-if="\$ctrl.availableAreas && \$ctrl.availableAreas.length > 0">
            <li ng-repeat="area in \$ctrl.availableAreas | orderBy:'name'">
              <label><input ng-model="area.selected" type="checkbox"/>{{ area.name }}</label>
            </li>
          </ul>
          <p ng-if="!(\$ctrl.availableAreas && \$ctrl.availableAreas.length > 0)">There are no areas that can be assigned</p>
        </form-section>

        <form-section form-title="'Branches'">
          <table class="table">
            <thead>
            <th class="text-left">Branch name</th>
            <th class="area-office-column">Area Office</th>
            </thead>
            <tbody>
            <tr ng-repeat="branch in \$ctrl.branches | orderBy:'name'">
              <td>
                <label ng-class="{'inactive': !branch.selected}">
                  <input ng-model="branch.selected"
                         type="checkbox"
                         ng-change="\$ctrl.onBranchChange(branch)"/>{{ branch.name }}
                </label>
              </td>
              <td class="area-office-column">
                <input ng-model="branch.areaOffice"
                       type="checkbox"
                       ng-change="\$ctrl.onAreaOfficeChange(branch)"/>
              </td>
            </tr>
            </tbody>
          </table>
        </form-section>
      </div>

    </form>

  </div>

  <div class="summary-actions">
    <button class="btn btn-warning"
            type="button"
            ng-click="\$ctrl.goBack()">
      Cancel
    </button>
    <button class="btn btn-primary"
            ng-disabled="\$ctrl.areaForm.\$pristine || \$ctrl.areaForm.\$invalid"
            type="button"
            ng-click="\$ctrl.save()">
      Save
    </button>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/areas/area-details/area-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;